import React, { useState } from 'react';
import Logo from './Logo';
import AppBanner from './AppBanner';
import { api } from './api';
import './Login.css';

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const data = await api.login(username, password);

      if (!data.access || !data.refresh) {
        setError('Сервер вернул неполные данные. Проверьте настройки бэкенда');
        setLoading(false);
        return;
      }

      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);

      if (onLoginSuccess) onLoginSuccess();
    } catch (error) {
      console.error('Login error:', error);
      let errorMessage = 'Ошибка входа';

      if (error.message) {
        if (error.message.includes('401') || error.message.includes('Неверный')) {
          errorMessage = 'Неверный логин или пароль';
        } else if (error.message.includes('fetch') || error.message.includes('Failed to fetch')) {
          errorMessage = 'Не удалось подключиться к серверу. Проверьте подключение к интернету';
        } else {
          errorMessage = error.message;
        }
      }

      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="gradient-shimmer"></div>
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="floating-shape shape-5"></div>
        <div className="sparkle sparkle-1"></div>
        <div className="sparkle sparkle-2"></div>
        <div className="sparkle sparkle-3"></div>
        <div className="sparkle sparkle-4"></div>
        <div className="sparkle sparkle-5"></div>
      </div>
      <div className="login-stack">
      <div className="login-container">
        <div className="login-header">
          <Logo size="large" />
          <h1 className="login-title">Электронная учительская</h1>
          <p className="login-subtitle">Войдите в свой аккаунт</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">Логин</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-input"
              placeholder="Введите логин"
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              placeholder="Введите пароль"
              required
              disabled={loading}
            />
          </div>
          {error && <div className="form-error">{error}</div>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? (
              <>
                <span className="button-spinner"></span>
                Вход...
              </>
            ) : (
              'Войти'
            )}
          </button>
        </form>
      </div>
      {/* «Приложение в RuStore» — под окном входа, закрыть нельзя */}
      <AppBanner variant="login" />
      </div>
    </div>
  );
}
